import axios from 'axios';

export default class ClasificacionService {

    getClasificacion() {            
        const url = process.env.VUE_APP_APIURL + `/api/clasificacion`;    
        return axios.get(url).then(res=>res.data);
    }

    updateClasificacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/clasificacionedicion`;     
        return axios.put(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    createClasificacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/clasificacionalta`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    deleteClasificacion(info){
        const url = process.env.VUE_APP_APIURL + `/api/clasificacionbaja`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }
}